import { defineMessage } from '@lingui/core/macro';
import { UnitJsonConfig } from '@/core/types/battle.types';

export const batyr: UnitJsonConfig = {
    id: 'batyr',
    unitName: defineMessage({ message: 'Batyr' }),
    stats: {
        hp: 90,
        stamina: 120,
        speed: 5,
        initiative: 55,
        armor: 20,
        evasion: 20,
        armorPenetration: 0.3,
        meleeSkill: 90,
        critChance: 20,
        critMult: 1.5,
        damageMin: 18,
        damageMax: 25,
    },
    skills: [
        {
        id: 'c_d_saber',
        name: defineMessage({ message: 'Sabre Slash' }),
        sort: 10,
        cost: 55,
        range: 1,
        hitChanceBonus: 5,
        iconRow: 1,
        iconCol: 0,
    },
    ],
    anchor: {
        x: 0.52,
        y: 0.7,
    },
    badge: {
        x: 70,
        y: -200,
    },
    unitPortrait: {
        row: 1,
        col: 2,
    },
} satisfies UnitJsonConfig;
